export default [
  {
    action: `read`,
    subject: `nawala`,
  },
];
